var React = require('react');

function FeatureTerrainParkMediumLarge (props) {
    return React.createElement("svg",props,[React.createElement("rect",{"x":"2","width":"288","height":"164","rx":"82","fill":"#F58021","key":0}),React.createElement("path",{"d":"M67.6094 115V46.2812H88.375L100.844 93.1562L113.172 46.2812H133.984V115H121.094V60.9062L107.453 115H94.0938L80.5 60.9062V115H67.6094ZM141.141 116.172L158.156 45.1094H168.047L150.844 116.172H141.141ZM175.859 115V46.8438H189.734V103.422H224.234V115H175.859Z","fill":"white","key":1})]);
}

FeatureTerrainParkMediumLarge.defaultProps = {"role":"presentation","viewBox":"0 0 290 164","fill":"none"};

module.exports = FeatureTerrainParkMediumLarge;

FeatureTerrainParkMediumLarge.default = FeatureTerrainParkMediumLarge;
